import { CycleController } from '../store/models/controllers';

const checkChannelAvailability = (list: CycleController[]): boolean => {
  return list.some((item) => item.channels.length);
};

export default checkChannelAvailability;
